export const TAB_ROUTES = {
    WORKING_NOW: 'working-now',
    GROUPS: 'worker-positions',
    INVITED: 'invited',
    BASKET: 'basket',
    SPECIALTIES: 'specialties',
};

export const WORKPLACES = 'workplaces';
